import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  data: function data() {
    return {
      loading: false,
      searchForm: {
        pn: 1,
        status: '0'
      }
    };
  },
  methods: {
    next: function next() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _context.n = 1;
              return _this.$api.getUsedList(_this.searchForm);
            case 1:
              res = _context.v;
              list = res.data.list;
              if (list.length > 0) {
                if (list[0] && list[0].id) {
                  console.log(list[0].id);
                  _this.$router.push({
                    path: "/used/update",
                    query: {
                      id: list[0].id,
                      from: _this.$route.query.from
                    }
                  });
                }
              } else {
                _this.$message.success("已清空~");
              }
              _this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};